import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../../_constants/validation-format-constants';

export class VendorMissingBillsParameterDto {
    isResolved: boolean;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    fromDate: Date;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    toDate: Date;

    communityId: number;

    getQueryString(): string {
        let url = '';

        if (this.isResolved !== null) {
            if (!url) {
                url = `?isResolved=${this.isResolved}`;
            } else {
                url += `&isResolved=${this.isResolved}`;
            }
        }

        if (this.fromDate) {
            if (!url) {
                url = `?fromDate=${dateJSONTransformer(this.fromDate)}`;
            } else {
                url += `&fromDate=${dateJSONTransformer(this.fromDate)}`;
            }
        }
        if (this.toDate) {
            if (!url) {
                url = `?toDate=${dateJSONTransformer(this.toDate)}`;
            } else {
                url += `&toDate=${dateJSONTransformer(this.toDate)}`;
            }
        }

        if (this.communityId) {
            if (!url) {
                url = `?communityId=${this.communityId}`;
            } else {
                url += `&communityId=${this.communityId}`;
            }
        }
        return url;
    }
}
